import React, {FC} from 'react';
import styled, {css} from 'styled-components';
import {mobileOnly} from '../../../constants/customMedia';
import {FONT_SIZES, FONT_WEIGHTS} from '../../../constants/typography';
import {Hint} from '../Hint/Hint';

interface ProductCardImageHintProps {
  hint?: string;
}

export const ProductCardImageHint: FC<ProductCardImageHintProps> = ({hint}) => {
  if (!hint) {
    return null;
  }
  return <ProductImageHint testId={'productAvailabilityHint'} label={hint} />;
};

const ProductImageHint = styled(Hint)`
  width: calc(100% - 8px);
  margin: 0 auto;
  bottom: 4px;
  position: relative;
  > span {
    font-size: ${FONT_SIZES.px12};
    font-weight: ${FONT_WEIGHTS.mediumBold};
  }

  ${mobileOnly(css`
    border-radius: 4px;
  `)}
`;
